import React from "react";
import ReactDOM from "react-dom/client";
import { Layout } from "./components/shared/site/Layout";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import NotFoundPage from "./components/NotFoundPage";
import ReactGA from "react-ga";
import EarthQuakePage from "./components/EarthQuakePage";
import Category from "./components/Category";
import Sitemap from "./components/Sitemap";

ReactGA.initialize("UA-125252458-2");
ReactGA.pageview(window.location.pathname + window.location.search);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/EarthQuakePage" element={<EarthQuakePage />} />
          <Route path="Category/:type/:param" element={<Category />} />
          <Route path="*" element={<NotFoundPage />} />
          {/* Sitemap Route */}
          <Route path="/sitemap.xml" element={<Sitemap />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
